export class ListUpdateStatusViewModel {
    empId: number;
    printCodeId: number;
    receiveHubId: number;
    shipmentStatusId: number;
    currentLat: number; 
    currentLng: number; 
    location: string;
    note: string;
    shipmentIds: number[];
}


// WEBPACK FOOTER //
// C:/Users/LIVE02/Documents/SSW/ThanhBuoi/TBE_CRM/src/app/view-model/listUpdateStatus.viewModel.ts